<template>
    <div
        style="position: fixed; z-index: 99999; bottom: 30px; right: 15px"
        @click="$emit('open')"
    >
        <span v-if="writing" class="badge bg-danger">
            <hollow-dots-spinner
                :animation-duration="3000"
                :dot-size="3"
                :color="'#fff'"
            />
        </span>
        <span
            v-else
            class="badge bg-danger animate__animated animate__infinite animate__tada"
        >
            <i class="fa fa-bell text-white"></i>
        </span>
    </div>
</template>

<script>
import { HollowDotsSpinner } from "epic-spinners";
export default {
    components: {
        HollowDotsSpinner,
    },
    name: "Unread",
    props: ["writing"],
};
</script>

<style lang="scss" scoped>
::-webkit-scrollbar-track {
    background-color: #f4f4f4;
}
::-webkit-scrollbar {
    width: 10px;
    background: #f4f4f4;
}
::-webkit-scrollbar-thumb {
    background: #00a0a9;
    border-radius: 25em;
}

.contacts-list {
    flex: 2;
    max-height: 350px;
    overflow-y: scroll;

    ul {
        list-style-type: none;
        padding-left: 0;

        li {
            display: flex;
            padding: 2px 2px 2px 10px;
            border-bottom: 1px solid #ededed;
            height: 50px;
            position: relative;
            cursor: pointer;

            &.selected {
                background: #dfdfdf;
            }

            span.unread {
                background: #82e0a8;
                color: #fff;
                position: absolute;
                right: 11px;
                top: 20px;
                display: flex;
                font-weight: 700;
                min-width: 20px;
                justify-content: center;
                align-items: center;
                line-height: 20px;
                font-size: 12px;
                padding: 0 4px;
                border-radius: 3px;
            }

            .avatar {
                flex: 1;
                display: flex;
                align-items: center;

                img {
                    width: 35px;
                    border-radius: 50%;
                    margin: 0 auto;
                }
            }

            .contact {
                flex: 3;
                font-size: 10px;
                overflow: hidden;
                display: flex;
                flex-direction: column;
                justify-content: center;

                p {
                    margin: 0;

                    &.name {
                        font-weight: bold;
                    }
                }
            }
        }
    }
}
</style>
